<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'customerLoanRequest',
  props: ['stockOutRow'],
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        ref_stock_out_or_receipt_id: null,
        customer_id: null,
        request_amount: null,
        paid_amount: null,
        customer_name: null,
        ref_invoice_or_receipt_no: null,
        request_source: 'Sale Invoice',
        product_name_en: null,
        color: null,
        engine_number: null,
        plate_number: null,
        vehicle_registration_date: null,
        issued_by: null,
        imei: null,
        year_of_m: null,
        trans_received_date: null,
        steering_wheel: null,
        sparepart_cost: null,
        product_grade: null,
        mc_number: null
      }
    }
  },
  computed: {
    currency_id() {
      if (this.stockOutRow.currency_id) {
        return this.stockOutRow.currency_id
      }
      return this.$store.state.authUser.sys_setting.default_currency_id
    }
  },
  mounted() {
    this.model.ref_stock_out_or_receipt_id = this.stockOutRow.stock_out_id
    this.model.customer_id = this.stockOutRow.customer_id
    this.model.request_amount = this.stockOutRow.amount_due
    this.model.paid_amount = this.stockOutRow.amount_paid
    this.model.customer_name = this.stockOutRow.customer_name
    this.model.ref_invoice_or_receipt_no = this.stockOutRow.invoice_no
    this.model.currency_id = this.currency_id
    this.model.product_name_en =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].product &&
        this.stockOutRow.details[0].product.product_name_en) ||
      null
    this.model.color =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].color) ||
      null
    this.model.engine_number =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].engine_number) ||
      null
    this.model.plate_number =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].plate_number) ||
      null
    this.model.vehicle_registration_date =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].vehicle_registration_date) ||
      null
    this.model.issued_by =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].issued_by) ||
      null
    this.model.imei =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].imei) ||
      null
    this.model.year_of_m =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].year_of_m) ||
      null
    this.model.trans_received_date =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].trans_received_date) ||
      null
    this.model.steering_wheel =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].steering_wheel) ||
      null
    this.model.sparepart_cost =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].sparepart_cost) ||
      null
    this.model.product_grade =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].product_grade) ||
      null
    this.model.mc_number =
      (this.stockOutRow.details[0] &&
        this.stockOutRow.details[0].serial_list &&
        this.stockOutRow.details[0].serial_list[0].mc_number) ||
      null
  },
  methods: {
    ...mapActions('wholesale/operation', ['onLoanRequest']),
    onSubmit() {
      this.loading = true
      this.onLoanRequest(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(({ response }) => {
          this.$toasted.error(response.message)
          this.errors = new Errors(response.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<template>
  <ts-loading-banner :loading="loading">
    <!-- begin widget-list -->
    <div class="widget-list rounded">
      <!-- begin widget-list-item -->
      <a href="#" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fas fa-user bg-yellow text-dark"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">{{ $t('saleInvoice.customer') }}</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-body text-opacity-50 fw-bold text-decoration-none"
        >
          {{ model.customer_name }}
        </div>
      </a>
      <!-- end widget-list-item -->
      <!-- begin widget-list-item -->
      <a href="#" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fas fa-dollar-sign bg-blue text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">
            {{ $t('saleInvoice.requestAmount') }}
          </h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-body text-opacity-50 fw-bold text-decoration-none"
        >
          <ts-display-currency
            :amount="model.request_amount"
            :currency_id="currency_id"
          />
        </div>
      </a>
    </div>
    <!-- end widget-list -->
    <div class="ts-space-y-3">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
        <ts-button @click.prevent="$emit('cancel')"
          >{{ $t('cancel') }}
        </ts-button>
        <ts-button @click.prevent="onSubmit" color="primary">{{
          $t('saleInvoice.submit')
        }}</ts-button>
      </div>
    </div>
  </ts-loading-banner>
</template>
